/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from "react";
import Utilities from "../../lib/Utilities";
import BuddibleSocket, { MsgIDList } from "../../lib/BuddibleSocket";
import NoticeManageTable from "./NoticeManageTable";
import axios from "axios";
import CodeList from "../../lib/CodeList";
import CommonLoader from "../CommonLoader";

const util = new Utilities();
const socket = new BuddibleSocket();
const codeList = new CodeList();

const NOTICE_TYPE = [
  { key: "NTA01", desc: "새소식" },
  { key: "NTA02", desc: "오픈예정" },
  { key: "NTA03", desc: "시스템공지" },
  { key: "NTA04", desc: "프로모션" },
  { key: "NTA05", desc: "입점업체현황" },
];

const _mClassName = "NoticeManage";

function NoticeManage(props) {
  const { pagesOpen, loginInfo } = props;
  const [isLoad, setIsLoad] = useState(true);
  const $searchText = useRef();
  const $searchLevel = useRef();

  useEffect(() => {
    if (isLoad && pagesOpen[_mClassName]) {
      setIsLoad(false);
    }
  }, [pagesOpen[_mClassName]]);
  const addNewData = (e) => {
    socket.sendLocalMessage(
      MsgIDList.EVENT_NOTICE_MANAGE_EDIT_MODAL_CALL,
      _mClassName,
      {},
      () => {}
    );
  };

  const searchFilterChanged = (e) => {
    const filters = {
      SEARCH_WORD: $searchText.current.value,
      SEARCH_LEVEL: $searchLevel.current.value,
    };

    socket.sendLocalMessage(
      MsgIDList.EVENT_NOTICE_MANAGE_FILTER_CHANGED,
      _mClassName,
      filters,
      () => {}
    );
  };

  const downloadExcel = (e) => {
    codeList.Modal.current.confirm(
      "엑셀파일을 다운로드 하시겠습니까?",
      (ret) => {
        if (ret) {
          axios({
            method: "POST",
            url: "//freiscop.gbts.co.kr/backside/notice/JS_notice_excel_export.php",
            responseType: "blob",
            headers: {
              "Content-Type": "application/json",
            },
            data: {
              SEARCH_WORD: $searchText.current.value,
              SEARCH_LEVEL: $searchLevel.current.value,
            },
          }).then((response) => {
            const url = window.URL.createObjectURL(
              new Blob([response.data], {
                type: response.headers["content-type"],
              })
            );
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
              "download",
              `공지사항리스트_${util.todayDate("YYYYMMDD")}.xls`
            );
            document.body.appendChild(link);
            link.click();
          });
        }
      }
    );
  };

  if (isLoad) return <CommonLoader />;
  return (
    <>
      <div className="container-fluid">
        <div className="row ">
          <div className="col">
            <div className="card">
              <div className="card-header">
                {/*필터 영역*/}
                <h6 className="card-subtitle pt-3 text-muted font-weight-bold">
                  {/*간편기간 영역*/}

                  <div
                    className="btn-toolbar mb-3 justify-content-md-between justify-content-end"
                    role="toolbar"
                  >
                    <div
                      className="btn-group mr-2 order-2 order-md-2 order-lg-1 mb-2 bm-sm-0"
                      role="group"
                    >
                      <button
                        className="btn  btn-outline-primary "
                        data-toggle="modal"
                        data-target="#NoticeEditModal"
                        onClick={addNewData}
                        alt={"신규등록"}
                        aria-label={"신규등록"}
                        type="button"
                      >
                        <i className="fas fa-plus" /> 신규등록
                      </button>

                      <button
                        className="btn  btn-outline-primary"
                        onClick={downloadExcel}
                      >
                        <i className="fas fa-download mr-2" />
                        엑셀파일로 받기
                      </button>
                    </div>

                    <div className="input-group order-1 order-md-1 order-lg-1  mb-2 bm-sm-0">
                      <select
                        className="custom-select form-control"
                        ref={$searchLevel}
                        onChange={searchFilterChanged}
                        style={{ minWidth: 150 }}
                      >
                        <option value="">분류</option>
                        {NOTICE_TYPE.map((menu, index) => {
                          return (
                            <option key={index} value={menu.key}>
                              {menu.desc}
                            </option>
                          );
                        })}
                      </select>

                      <input
                        type="text"
                        className="form-control"
                        placeholder="검색어"
                        aria-label="검색어"
                        aria-describedby="btnGroupAddon2"
                        onKeyPress={(e) => {
                          // console.log(e);
                          if (e.charCode === 13) {
                            searchFilterChanged(e);
                          }
                        }}
                        ref={(ref) => ($searchText.current = ref)}
                      />

                      <button
                        className="input-group-text btn btn-primary border-left-0 rounded-0 rounded-top-right rounded-bottom-right"
                        onClick={searchFilterChanged}
                      >
                        <i className="fas fa-search mr-2" />
                        검색
                      </button>
                    </div>
                  </div>
                </h6>
              </div>
              <NoticeManageTable />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default NoticeManage;
